import {ActionsEnum} from "@/entity/ActionsEnum";

export var menuItems = [
    {
        action: 'mdi-circle',
        title: 'Genel',
        active: true,
        items: [
            {
                title: 'Kullanıcılar' ,
                route:  '/genel/kullanicilar',
                action: ActionsEnum.Users
            },
            {
                title: 'Yorumlar' ,
                route:  '/genel/comments',
                action: ActionsEnum.Comments
            },
            {
                title: 'Form Kayıtları' ,
                route:  '/genel/formkayitlari',
                action: ActionsEnum.Forms
            },
            {
                title: 'Sayfalar' ,
                route:  '/genel/sayfalar',
                action: ActionsEnum.Pages
            },
            {
                title: 'SSS' ,
                route:  '/genel/sss',
                action: ActionsEnum.Pages
            },
            {
                title: 'Programlar' ,
                route:  '/genel/programlar',
                action: ActionsEnum.Pages
            },
        ],
    },
    {
        action: 'mdi-circle',
        title: 'Site Ayarları',
        active: false,
        items: [
            {
                title: 'Şubeler' ,
                route:  '/ayarlar/siteler',
                action: ActionsEnum.Sites
            },
            {
                title: 'Genel' ,
                route:  '/ayarlar/siteconfig',
                action: ActionsEnum.Config
            },
            {
                title: 'Slider' ,
                route:  '/ayarlar/slider',
                action: ActionsEnum.Slider
            },
            {
                title: 'Banner' ,
                route:  '/ayarlar/banner',
                action: ActionsEnum.Banner
            },
            {
                title: 'Ekip' ,
                route:  '/ayarlar/ekip',
                // Yetki sayfa adı = API denetleyicisi (admin/team); kısıtlı
                // yöneticide menü, sunucunun izin verdiği sayfayla aynı olsun
                action: 'team'
            },
            {
                title: 'Seo Ayarları' ,
                route:  '/ayarlar/seosettings',
                action: ActionsEnum.Seo
            },
            {
                title: 'Teknik SEO / İzleme' ,
                route:  '/ayarlar/teknikseo',
                action: ActionsEnum.Config
            },
            {
                title: 'Görsel ve Animasyon' ,
                route:  '/ayarlar/gorsel',
                action: ActionsEnum.Config
            },
        ],
    }
];